export default __webpack_public_path__ + "static/media/IMG_1299.5027e1fd.jpeg";